import classNames from 'classnames';
import React from 'react';
import type { SpanValue } from '../formats/Span';
import ImageNode, { useImageSrc } from './ImageNode';
import * as styles from './SingleImage.module.scss';
import type { CarouselItem } from './types';
import { isUploadedCarouselItem } from './types';

interface SingleImageProps {
  image: CarouselItem;
  span: SpanValue | null;
}

const SingleImage = ({ image, span }: SingleImageProps) => {
  const src = useImageSrc(image, { fullscreen: false });
  const isUploading = !isUploadedCarouselItem(image);

  return (
    <div
      className={classNames(styles.container, {
        [styles.isFullSpan]: span === 'full',
        [styles.isHalfSpan]: span === 'half',
      })}
    >
      {src && (
        <ImageNode
          className={classNames(styles.image, {
            [styles.uploading]: isUploading,
          })}
          width={image.width}
          image={image}
        />
      )}
      {isUploading && <div className={styles.progress} />}
    </div>
  );
};

export default SingleImage;
